define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.MFBooleanDomain = void 0;
    class MFBooleanDomain {
        static initialise() {
            if (!this.isInitialised) {
                this.isInitialised = true;
                this.values = [
                    { key: MFBooleanDomain.No, value: "No" },
                    { key: MFBooleanDomain.Yes, value: "Yes" }
                ];
                this.KeyIndex = {};
                this.KeyIndex[MFBooleanDomain.No] = 0;
                this.KeyIndex[MFBooleanDomain.Yes] = 1;
                this.ValueIndex = {};
                this.ValueIndex["No"] = 0;
                this.ValueIndex["Yes"] = 1;
            }
        }
        static get Values() {
            this.initialise();
            return this.values;
        }
        static findByValue(value) {
            this.initialise();
            if (this.ValueIndex[value] != null) {
                return this.Values[this.ValueIndex[value]];
            }
            return null;
        }
        static findByKey(key) {
            this.initialise();
            if (this.KeyIndex[key] != null) {
                return this.Values[this.KeyIndex[key]];
            }
            return null;
        }
    }
    exports.MFBooleanDomain = MFBooleanDomain;
    Object.defineProperty(MFBooleanDomain, "No", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 0
    });
    Object.defineProperty(MFBooleanDomain, "Yes", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 1
    });
    Object.defineProperty(MFBooleanDomain, "isInitialised", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
});
